<template>
    <div class="owner-access-signup">
        <p class="section__description">
            {{
                $t('owner_access_signup.text', {
                    country: $t(`localization.countries.${country}`),
                })
            }}
        </p>
        <template v-if="!subscribed">
            <form @submit.prevent="subscribe">
                <input
                    v-model.trim="email"
                    class="input owner-access-signup__email"
                    type="email"
                    :placeholder="$t('form_inputs.email_address_label')"
                />
                <button
                    :disabled="isSubscribing"
                    type="submit"
                    class="button button--primary button--full-width owner-access-signup__button"
                >
                    <LoadingIndicator v-if="isSubscribing" />
                    <template v-else>
                        {{ $t('owner_access_signup.signup_button') }}
                    </template>
                </button>
            </form>
        </template>
        <Notice v-if="subscribeError" class="owner-access-signup__notice" type="warning">
            {{ $t('errors.an_error_occurred') }}
            {{ $t('errors.try_again_or_contact_us') }}
        </Notice>
        <Notice v-if="subscribed" class="owner-access-signup__notice" type="success">
            {{ $t('common.thank_you') }}
        </Notice>
    </div>
</template>

<script>
import LoadingIndicator from '~/components/LoadingIndicator.vue';
import Notice from '~/components/Notice.vue';
import SubscriptionService from '~/services/SubscriptionService';

export default {
    components: { LoadingIndicator, Notice },
    props: {
        country: {
            type: String,
            default() {
                return this.$store.getters.siteCountryCodeWithFallback;
            },
        },
        presetEmail: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            email: this.presetEmail,
            subscribed: false,
            isSubscribing: false,
            subscribeError: null,
        };
    },
    methods: {
        subscribe() {
            this.isSubscribing = true;
            this.subscribeError = null;

            const list = `${this.country.toLowerCase()}_owner_access`;
            const api = new SubscriptionService(this);
            api.subscribe({ list, email: this.email })
                .then(() => {
                    this.subscribed = true;
                })
                .catch(err => {
                    this.subscribeError = err;
                    this.$sentry.captureException(err);
                })
                .finally(() => {
                    this.isSubscribing = false;
                });
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.owner-access-signup {
    text-align: left;

    &__button {
        margin-top: 10px;
    }

    &__notice {
        margin-top: 10px;
    }
}
</style>
